import React, { useState } from "react";
import { useParticipant } from "../../contexts/ParticipantContext";
import { Participant } from "../../models/Participant";
import { Field, Label } from "../../design/fieldset";
import { Button } from "../../design/button";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useChooseParticipantDialog } from "../../providers/ChooseParticipantDialogProvider";
import { Text } from "../../design/text";

interface SelectParticipantFieldProps {
  label: string;
  value: Participant["_id"] | undefined;
  onChange: (value: Participant["_id"] | undefined) => void;
  description?: string;
}

const SelectParticipantField: React.FC<SelectParticipantFieldProps> = ({
  label,
  value,
  onChange,
  description,
}) => {
  const { participants } = useParticipant();
  const { openDialog } = useChooseParticipantDialog();

  const removeParticipant = () => {
    onChange(undefined);
  };

  const selectedParticipant = participants.find((p) => p._id === value);

  return (
    <Field>
      <Label>{label}</Label>
      <div
        className={
          "flex items-center justify-between border rounded-lg p-2 cursor-pointer hover:border-gray-400 transition"
        }
        onClick={() => openDialog(onChange)}
        role="button"
        aria-label={`Select ${label}`}
      >
        {selectedParticipant ? (
          <Text>{selectedParticipant.name}</Text>
        ) : (
          <Text>Select a participant...</Text>
        )}
        {selectedParticipant && (
          <Button color="red" onClick={removeParticipant}>
            <XMarkIcon className="w-4 h-4" />
          </Button>
        )}
      </div>
    </Field>
  );
};

export default SelectParticipantField;
